/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseDetailResponse } from '../../models/base-detail-response';
import { SaveBaseRequest } from '../../models/save-base-request';

export interface UpdateBase$Params {
  id: number;
      body: SaveBaseRequest
}

export function updateBase(http: HttpClient, rootUrl: string, params: UpdateBase$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, updateBase.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseDetailResponse>;
    })
  );
}

updateBase.PATH = '/api/scheduler/bases/{id}';
